import { useMemo } from 'react';
import { useSpotMarketsLookup } from 'src/hooks/spotMarkets/useSpotMarketsLookup';
import { usePerpMarketsLookup } from 'src/hooks/perpMarkets/usePerpMarketsLookup';
import { UIMarket } from '@drift/common';

export const useSpotMarketTabs = () => {
	const spotMarketsLookup = useSpotMarketsLookup();

	return useMemo(() => {
		return [{ label: 'All', value: 'all_markets' }].concat(
			spotMarketsLookup.map((market) => ({
				label: market.symbol,
				value: market.symbol,
			}))
		);
	}, [spotMarketsLookup]);
};

/**
 * All perp and spot markets without prediction markets.
 */
const _useAllMarketsExceptPredictionTabs = () => {
	const perpMarketsLookup = usePerpMarketsLookup();
	const spotMarketsLookup = useSpotMarketsLookup();

	return useMemo(() => {
		return [{ label: 'All', value: 'all_markets' }]
			.concat(
				perpMarketsLookup
					.filter((config) => !UIMarket.checkIsPredictionMarket(config))
					.map((market) => ({
						label: market.symbol,
						value: market.symbol,
					}))
			)
			.concat(
				spotMarketsLookup.map((market) => ({
					label: market.symbol,
					value: market.symbol,
				}))
			);
	}, [perpMarketsLookup, spotMarketsLookup]);
};

export const usePerpMarketsOnlyTabs = ({
	withBaseAssetSymbol = false,
}: {
	withBaseAssetSymbol?: boolean;
} = {}) => {
	const perpMarketsLookup = usePerpMarketsLookup();

	return useMemo(() => {
		return [{ label: 'All', value: 'all_markets' }].concat(
			perpMarketsLookup
				.filter((config) => !UIMarket.checkIsPredictionMarket(config))
				.map((market) => ({
					label: withBaseAssetSymbol ? market.baseAssetSymbol : market.symbol,
					value: market.symbol,
				}))
		);
	}, [perpMarketsLookup]);
};
